import React, { useEffect } from 'react';
import {Col, Row} from 'reactstrap';
import {connect, useSelector} from "react-redux";
import {getStateByPath} from "../../../redux/selectors";

// components
import ParamSettingsList from "./_list";
import {showLoader} from "../../../components/loader/loader";
import {ADD_STATE, REMOVE_STATE, setApp} from "../../../redux/actions/generics/IndexedActions";

function ParamSettingsGeneral(props) {
    const path = props.path || 'configuration/paramSettings';
    const componentState = useSelector(state => getStateByPath(state, path));
    const { loading } = componentState?.data || false;

    useEffect(() => {
        props.ADD_STATE(path);

        return () => {
            props.REMOVE_STATE(path);
        }
    }, []);

    useEffect(() => {
        if (props.app !== null)
            props.setApp(props.app);
    },[]);

    return <>
        <div>
            {loading && showLoader()}
            <Row>
                <Col md="12">
                    {componentState && <ParamSettingsList path={path} generalPropouse={true}/>}
                </Col>
            </Row>
        </div>
    </>
}

const mapStateToProps = state => ({
});

const mapActionsToProps = ({
    ADD_STATE,
    REMOVE_STATE,
    setApp,
});

export default connect(mapStateToProps, mapActionsToProps)(ParamSettingsGeneral)

